const percIncrease = (a, b) => {
    let percent;
    if (b !== 0) {
        if (a !== 0) {
            percent = ((b - a) / a) * 100;
        } else {
            percent = b * 100;
        }
    } else {
        percent = -a * 100;
    }
    return Math.floor(percent);
};

const animateLogos = () => {
    const customerLogos = document.querySelector('.customers');
    const customerLogosPos = customerLogos.getBoundingClientRect();
    const scrollPos = percIncrease(window.screen.height, customerLogosPos.top);

    const row1 = customerLogos.querySelector('.customers__logos-row-1');
    row1.style.setProperty('--extensions-icon-row-translate-x', `${scrollPos * 2}px`);

    const row2 = customerLogos.querySelector('.customers__logos-row-2');
    row2.style.setProperty('--extensions-icon-row-translate-x', `${scrollPos * 4}px`);
};

const handleIntersectionObserver = (entries) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) {
            window.removeEventListener('scroll', animateLogos);
        } else {
            window.addEventListener('scroll', animateLogos);
        }
    });
};

const panelObserver = new IntersectionObserver(handleIntersectionObserver, {
    rootMargin: '0px 0px',
});

const init = () => {
    const customerLogos = document.querySelector('.customers');
    panelObserver.disconnect();
    panelObserver.observe(customerLogos);
};

export { init as default };
